import styled from "styled-components";

import { PrimaryButton } from "components/Button";

export const EmptyBasketContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 24px 60px;
  gap: 64px;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding: 407px 0 0 0;
    @media only screen and (orientation: landscape) {
      padding: 70px 0 0 0;
    }
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("mdl")} {
    @media only screen and (orientation: landscape) {
      padding: 200px 0 0 0;
    }
  }

  ${({ theme }) => theme.customTheme.breakpoints.down("md")} {
    @media only screen and (orientation: landscape) {
      padding: 0;
    }
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    padding: 0;
    gap: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 64px 0px 0px;
  gap: 24px;
  align-self: stretch;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding: 0;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    gap: 32px;
    padding: 164px 378px;
  }
`;

export const TotalToday = styled.span`
  background: ${({ theme }) => theme.customTheme.palette.grey.lightF3};
  border-radius: 100px;
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(14)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  padding: 4px 12px;
  text-align: center;
  color: ${({ theme }) => theme.customTheme.palette.grey.grey5E};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
    padding: 5px 23px;
    width: fit-content;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(24)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(32)};
  }
`;

export const Amount = styled.strong`
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(14)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  color: ${({ theme }) => theme.customTheme.palette.black.black25};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(24)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(32)};
  }
`;

export const StyledPageTitle = styled.span`
  font-family: ThemeFontBold;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(24)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(32)};
  color: ${({ theme }) => theme.customTheme.palette.black.black1};

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(40)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(48)};
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    font-size: ${({ theme }) => theme.customTheme.pxToRem(40)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(48)};
  }
`;

export const SeeOffersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 0 0;
  width: 100%;
  margin-top: 230px;

  ${({ theme }) => theme.customTheme.breakpoints.up("sm")} {
    margin-top: 450px;
    @media only screen and (orientation: landscape) {
      margin: 0;
      padding: 0;
    }
    & button {
      width: 336px;
    }
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("sml")} {
    margin-top: 290px;
    @media only screen and (orientation: landscape) {
      margin-top: 0;
    }
    & button {
      width: 336px;
    }
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    margin: 0;
    padding: 0;

    & button {
      width: 336px;
    }
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    margin: 0;
    padding: 24px 175px;

    & button {
      width: 327px;
    }
  }
`;

export const StartShoppingButton = styled(PrimaryButton)`
  font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
  line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
  width: 100%;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    margin: auto;
    width: fit-content;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: 22.5%;
  }
`;
